<template>
    <main>
        <header class="solution">
            <div class="container">
                <h1>Solutions</h1></div>
            <div class="clip-path-one green70"></div>
        </header>

        <section class="solution-area">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8 text-center">
                        <h3>{{ data.title }}</h3>
                        <p>{{ data.subtitle }}</p>
                    </div>
                </div>
                <div class="row justify-content-md-center solution-list">

                    <div class="col-md-6 col-lg-4" v-for="solution of data.cards">
                        <div class="card">
                            <div class="card-content" :class="solution.class.size">
                                <h3>{{ solution.title }}</h3>
                                <p>{{ solution.text }}</p>
                            </div>
                            <div class="card-content">

                                <router-link :to="solution.link" v-if="solution.link !== 'epcircle'" tag="a">More details +</router-link>
                                <a v-if="solution.link === 'epcircle'" :href=" solution.linkout" tag="a" ></i>Go to Epcircle site +</a>

                            </div>
                            <div class="card-bottom" :style="{ 'background-image': 'url(' + solution.imageUrl + ')' }"></div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>

        <call-action :data="data.callToAction"></call-action>

    </main>
</template>

<script>
    export default {
        data() {
            return {
                data: {
                    title: 'Learn about solutions that Alphabet Sphere can offer you',
                    //subtitle: 'Nossas atividades são focadas em inovar e melhorar os ambientes organizacionais para pessoas e empresas. Desenvolvemos e fornecemos soluções tecnológicas com qualidade, profissionalismo e ética.',
                    cards: [
                        {
                            title: 'Solutions for Education',
                            text: 'Our learning solutions are optimized for your business strategic goals. In addition to provide platforms and mobile solutions, we also produce a variety of types of media such as eBooks, videos, infographics, questions, etc.; all of them highly adapted to context and aim to transform the learning processes into something more light and dynamic.',
                            imageUrl: 'static/images/headers/solutions-edu.jpg',
                            link: '/solucoes/educacionais',
                            class: {
                                img: 'edu',
                                size: 'large-size'
                            },
                        },
                        {
                            title: 'Energy Labelling',
                            text: 'Our high-resolution EPC toolbox is based on a user-friendly and airtight mobile app for in-situ data collection, combined with a state-of-the-art energy calculation engine deployed in the cloud, that utilizes high-precision data and images from satellites to increase the accuracy of EPC.',
                            imageUrl: 'static/images/headers/epcircle.jpg',
                            link: 'epcircle',
                            class: {
                                img: 'est',
                                size: 'large-size'
                            },
                            linkout: 'http://epcircleenergy.com/',
                        },
                        {
                            title: 'Custom Projects',
                            text: 'Needing a custom project for you company? Check the different and many advantages our custom development can bring to your business.',
                            imageUrl: 'static/images/headers/solutions-pro.jpg',
                            link: '/solucoes/projetos-personalizados',
                            class: {
                                img: 'com',
                                size: 'large-size'
                            },
                        },
                       
                    ],
                    callToAction: {
                        title: {
                            before: 'Any ',
                            after: 'questions?'
                        },
                        class: '',
                        button: {
                            text: 'Contact us!',
                            link: '/contato'
                        }
                    },
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Solutions.vue